<template lang="pug">
v-tooltip(bottom)
  template(v-slot:activator="{ on, attrs }")
    span(v-bind="attrs", v-on="on")
      v-btn(
        outlined,
        height="40",
        class="dashboard-reset-button dashboard-action-button dashboard-action-button--icon",
        :disabled="disabled",
        @click="$emit('reset')"
      )
        v-icon mdi-refresh
  span {{ tooltip }}
</template>

<script>
export default {
  name: "ResetButton",

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: "Resetar formulário e limpar filtros salvos"
    }
  }
};
</script>

<style scoped>
.dashboard-action-button {
  border-color: #c7d1dc !important;
  box-shadow: none !important;
  color: #6f7d8c !important;
  font-size: 11px !important;
  font-weight: 500;
  letter-spacing: 0.01em !important;
  text-transform: none !important;
}

.dashboard-action-button::before {
  background-color: transparent !important;
}

.dashboard-action-button .v-icon {
  color: #748291 !important;
}

.dashboard-action-button--icon {
  background-color: #f3f6f9;
}

.dashboard-reset-button {
  display: flex;
  min-width: 0 !important;
  width: 100%;
}
</style>
